<template>
  <v-form
    fast-fail
    @submit.prevent="saveData"
    class="edit-user"
    v-click-outside="outsideCancelAction"
  >
    <div v-if="!isLoading">
      <h2 class="title mb-2">
        {{ $t("capacitySettings.capacitySettingModal.title") }}
      </h2>
      <v-select
        :label="
          $t('capacitySettings.capacitySettingModal.ticketBuyerTypeInput')
        "
        :items="this.ticketBuyerTypes"
        v-model="userData.ticketBuyerType"
        item-title="title"
        item-value="id"
        clearable
        tabindex="-1"
      ></v-select>

      <div class="content pt-0">
        <div
          class="mb-5 pb-1 mt-0"
          :class="focusedFlatpickrFrom ? 'focused_flatpickr' : 'flatpickr'"
        >
          <label
            for="date_from"
            :class="
              labelForFlatpickrFrom
                ? 'flatpickrLabel ms-1'
                : 'flatpickrHiddenLabel'
            "
            >{{ $t("capacitySettings.capacitySettingModal.dateFromInput") }}
            <label
              :class="labelForFlatpickrFrom ? 'unclickedLabel' : 'clickedLabel'"
            >
              {{ $t("capacitySettings.capacitySettingModal.dateFromInput") }}
            </label>
          </label>
          <div class="date-picker">
            <flat-pickr
              v-model="userData.date_from"
              :config="configFrom"
              name="date_from"
              tabindex="-1"
            ></flat-pickr>
          </div>
        </div>

        <div
          class="mb-5 pb-1 mt-0"
          :class="focusedFlatpickrTo ? 'focused_flatpickr' : 'flatpickr'"
        >
          <label
            for="date_to"
            :class="
              labelForFlatpickrTo
                ? 'flatpickrLabel ms-1'
                : 'flatpickrHiddenLabel'
            "
            >{{ $t("capacitySettings.capacitySettingModal.dateToInput") }}
            <label
              :class="labelForFlatpickrTo ? 'unclickedLabel' : 'clickedLabel'"
            >
              {{ $t("capacitySettings.capacitySettingModal.dateToInput") }}
            </label></label
          >
          <div class="date-picker">
            <flat-pickr
              v-model="userData.date_to"
              :config="configTo"
              name="date_to"
              tabindex="-1"
            ></flat-pickr>
          </div>
        </div>
      </div>

      <v-text-field
        v-model="userData.capacity"
        :label="$t('capacitySettings.capacitySettingModal.capacityLimit')"
        tabindex="-1"
      ></v-text-field>
      <div class="btn-row mt-6">
        <v-btn @click="cancelAction">
          {{ $t("capacitySettings.capacitySettingModal.cancel") }}
        </v-btn>
        <v-btn
          class="mb-2"
          @click="capacitySettingsDelete"
          color="red"
          v-if="!isCreate"
        >
          {{ $t("capacitySettings.capacitySettingModal.delete") }}
        </v-btn>
        <v-btn :disabled="!visibleButton" color="primary" @click="saveData">
          {{ $t("capacitySettings.capacitySettingModal.save") }}
        </v-btn>
      </div>
    </div>
    <div v-else class="loading">
      <v-progress-circular
        v-if="isLoading"
        size="73.5"
        indeterminate
        class="loading-circle"
      ></v-progress-circular>
    </div>
  </v-form>
</template>

<script>
import { mapActions } from "vuex";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Hungarian } from 'flatpickr/dist/l10n/hu.js';

export default {
  name: "EditcapacitySettingsModal",
  components: {
    flatPickr,
  },
  props: {
    user: {
      type: Object,
      required: false,
    },
    isCreate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userData: {
        id: undefined,
        ticketBuyerType: null,
        capacity: null,
        date_from: "",
        date_to: "",
      },

      ticketBuyerTypes: [],

      // For Flatpicker
      configFrom: {
        altFormat: "Y-m-d",
        altInput: true,
        dateFormat: "Y-m-d",
        allowInput: false,
        enableTime: false,
        disableMobile: true,
        locale: Hungarian,
        onOpen: () => {
          this.hiddenLabelFrom = true;
          this.focusedFlatpickrFrom = true;
        },
        onClose: () => {
          this.hiddenLabelFrom = false;
          this.focusedFlatpickrFrom = false;
        },
      },
      configTo: {
        altFormat: "Y-m-d",
        altInput: true,
        dateFormat: "Y-m-d",
        allowInput: false,
        enableTime: false,
        disableMobile: true,
        locale: Hungarian,
        onOpen: () => {
          this.hiddenLabelTo = true;
          this.focusedFlatpickrTo = true;
        },
        onClose: () => {
          this.hiddenLabelTo = false;
          this.focusedFlatpickrTo = false;
        },
      },

      hiddenLabelFrom: false,
      hiddenLabelTo: false,

      focusedFlatpickrFrom: false,
      focusedFlatpickrTo: false,

      isLoading: false,
    };
  },
  mounted() {
    this.getWebshopUserTypeMethod();
    if (!this.isCreate) {
      this.getDatas();
    }
  },
  methods: {
    ...mapActions({ getWebshopUserType: "users/getWebshopUserType" }),

    getWebshopUserTypeMethod() {
      this.isLoading = true;
      this.getWebshopUserType()
        .then((res) => {
          this.ticketBuyerTypes = res.list;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err), (this.isLoading = false);
        });
    },

    getDatas() {
      this.userData.id = this.user.id;
      this.userData.ticketBuyerType = {
        title: this.user.webshop_user_type,
        id: this.user.webshop_user_type_id,
      };
      this.userData.capacity = parseInt(this.user.limit);
      this.userData.date_from = this.user.start_date;
      this.userData.date_to = this.user.end_date;
    },

    cancelAction() {
      if (document.activeElement.tagName != "INPUT") {
        this.emitter.emit("closeModal");
      }
    },

    outsideCancelAction(event) {
      const clickedElement = event.target;
      const classList = clickedElement.classList;

      if (classList.contains("v-overlay__scrim")) {
        this.cancelAction();
      }
    },

    saveData() {
      if (this.isCreate) {
        const createPayload = {
          product_id: this.$route.params.id,
          webshop_user_type_id: this.userData.ticketBuyerType,
          limit: parseInt(this.userData.capacity),
          start_date: this.userData.date_from,
          end_date: this.userData.date_to,
        };
        this.$emit("createNewCapacitySettings", createPayload);
      } else {
        const createPayload = {
          product_id: this.$route.params.id,
          id: this.userData.id,
          webshop_user_type_id: this.userData.ticketBuyerType.id
            ? this.userData.ticketBuyerType.id
            : this.userData.ticketBuyerType,
          limit: parseInt(this.userData.capacity),
          start_date: this.userData.date_from,
          end_date: this.userData.date_to,
        };
        this.$emit("saveUser", createPayload);
      }
      this.emitter.emit("closeModal");
    },

    capacitySettingsDelete() {
      const payload = {
        title: this.$t("capacitySettings.deleteModdal.title"),
        subTitle: this.$t("capacitySettings.deleteModdal.subTitle"),
        userId: this.userData.id,
      };
      this.emitter.emit("showConfirmModal", payload);
    },
  },
  computed: {
    labelForFlatpickrFrom() {
      return (
        !this.hiddenLabelFrom &&
        (this.userData.date_from === "" || this.userData.date_from === null)
      );
    },
    labelForFlatpickrTo() {
      return (
        !this.hiddenLabelTo &&
        (this.userData.date_to === "" || this.userData.date_to === null)
      );
    },
    visibleButton() {
      return (
        this.userData.ticketBuyerType !== null &&
        this.userData.capacity !== null &&
        this.userData.date_from !== "" &&
        this.userData.date_to !== ""
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.flatpickr {
  position: relative;
  margin-top: 0.5px;
  background-color: rgba(232, 232, 232, 0.4);
  max-height: 55px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}
.focused_flatpickr {
  position: relative;
  margin-top: 0.5px;
  background-color: rgba(191, 191, 191, 0.7);
  max-height: 55px;
  border-bottom: 2px solid;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}
.flatpickr:hover {
  background-color: rgba(232, 232, 232, 0.7);
}
.edit-user {
  min-width: 400px;
  padding: 24px;
  @media (max-width: 520px) {
    min-width: 300px;
    padding: 12px;
  }
  .btn-row {
    display: flex;
    justify-content: space-between;
    @media (max-width: 520px) {
      flex-direction: column;
      gap: 12px;
    }
  }
}
</style>
